import { render, staticRenderFns } from "./Group-Edit-File.vue?vue&type=template&id=1dd9c94d&scoped=true&"
import script from "./Group-Edit-File.vue?vue&type=script&lang=js&"
export * from "./Group-Edit-File.vue?vue&type=script&lang=js&"
import style0 from "./Group-Edit-File.vue?vue&type=style&index=0&id=1dd9c94d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd9c94d",
  null
  
)

export default component.exports